import React, { useState, useEffect } from "react"
import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import ManageInfo from "pages/manage/info"
import Button from "@mui/material/Button"
import InvoiceModal from "./invoice"

export interface InvoiceDetail {
  medical_record_id: string
  medical_record_name: string
  catv_name: string
  estate_name: string
  facility_name: string
  is_poc: number
}

export interface InvoiceList {
  target_month: string
  medical_record_count: number
  medical_record_count_poc: number
  invoice_detail_list: InvoiceDetail[]
}

interface NotificationProps {
  content: string
  invoiceCount: number
  invoicePocCount: number
  invoiceList?: InvoiceList[]
}

function Notification({
  content,
  invoiceCount,
  invoicePocCount,
  invoiceList = []
}: NotificationProps): React.ReactElement {
  const [info, setInfo] = useState<string>(content)
  const [infoUpdate, setInfoUpdate] = useState<boolean>(false)
  const [showUpdateInfoButton, setShowUpdateInfoButton] = useState<boolean>(false)
  const [showInvoiceModal, setShowInvoiceModal] = useState<boolean>(false)

  useEffect(() => {
    const auth = localStorage.getItem("account_type")
    if (auth === "service") {
      setShowUpdateInfoButton(true)
    }
    setInfo(content)
  }, [content])

  // お知らせ更新ボタン
  const handleInfo = () => {
    setInfoUpdate(true)
  }

  // 編集完了
  const handleInfoClose = (body: string | null) => {
    setInfoUpdate(false)
    if (body !== null) {
      setInfo(body)
    }
  }

  return (
    <>
      {showInvoiceModal && (
        <InvoiceModal
          onClose={() => {
            setShowInvoiceModal(false)
          }}
          invoiceList={invoiceList}
        />
      )}
      <MDBox display="flex">
        <MDBox
          sx={{
            width: "100%",
            textAlign: "right",
            marginTop: "-22px",
            paddingRight: "24px",
            fontSize: "0.75em",
            color: "#7B809A"
          }}
        >
          直近月の運用数：
          <a
            onClick={() => {
              setShowInvoiceModal(true)
            }}
            style={{
              color: "#1A73E8",
              textDecoration: "underline",
              cursor: "pointer"
            }}
          >
            {/* 「うちPoC XX」の表現に変更 */}
            {invoiceCount} (内 PoC {invoicePocCount})
          </a>
        </MDBox>
      </MDBox>

      {infoUpdate && <ManageInfo body={info} onClose={handleInfoClose} />}

      {info !== "" ? (
        <Card sx={{ height: "100%", padding: "20px" }}>
          <MDBox display="flex">
            <MDTypography variant="h4" fontWeight="medium">
              お知らせ
            </MDTypography>
            {showUpdateInfoButton && (
              <MDBox sx={{ position: "absolute", top: "20px", right: "20px" }}>
                <Button variant="contained" color="primary" size="small" sx={{ color: "#FFF" }} onClick={handleInfo}>
                  編集
                </Button>
              </MDBox>
            )}
          </MDBox>
          <MDBox sx={{ maxHeight: "120px", overflowY: "auto" }}>
            <MDTypography
              variant="body2"
              color="text"
              fontWeight="regular"
              sx={{ fontSize: "14px" }}
              dangerouslySetInnerHTML={{
                __html: info.replace(/\n/g, "<br />")
              }}
            />
          </MDBox>
        </Card>
      ) : (
        <>
          {showUpdateInfoButton && (
            <Card sx={{ height: "100%", padding: "20px" }}>
              <MDBox display="flex">
                <MDTypography variant="h4" fontWeight="medium">
                  お知らせ
                </MDTypography>
                <MDBox sx={{ position: "absolute", top: "20px", right: "20px" }}>
                  <Button variant="contained" color="primary" size="small" sx={{ color: "#FFF" }} onClick={handleInfo}>
                    編集
                  </Button>
                </MDBox>
              </MDBox>
            </Card>
          )}
        </>
      )}
    </>
  )
}

export default Notification
